// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>125</span>&nbsp;&nbsp;I am your servant; O grant me understanding,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;that I may know your testimonies.<br> </p> </div></div>";
// Exports
module.exports = code;